import Vue from 'vue';
import Vuex from 'vuex'
import {getGlobalData, getShopUISetting} from '@/api/global'
import createEnum from '@/libs/enum'
import {getUserRoles} from "@/api";
import chat from './module/chat'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
        isUsed: false,
        roles: null,
        roleAccess: null,
        rolePermission: null,
        removeClerkRole: null,
        isResigned: null,
        shop: null,
        order: null,
        label: null,
        ddConfig: null,
        ShopPlatformEnum: null,
        UserSexEnum: null,
        UserInfoEnum: null,
        UserViolationTypeEnum: null,
        UserGradeMap: null,
        userTagMap: null,
        ConstellationEnum: null,
        ClerkSexEnum: null,
        ClerkStatusEnum: null,
        ClerkItemTypeEnum: null,
        ClerkGradeMap: null,
        ClerkGroupMap: null,
        OrderTypeEnum: null,
        OrderStatusEnum: null,
        DispatchOrderStatusEnum: null,
        // OrderServiceTypeEnum: null,
        // OrderServiceDurationEnum: null,
        PriceTypeEnum: null,
        OrderPayModeEnum: null,
        OrderRatioTypeEnum: null,
        TimeUnitEnum: null,
        AccountBalanceLogActionEnum: null,
        featureValue: null,
        shopUISetting: null,
        needConfirmClerkAgreement: null,
        clerkSetting: null,
        shopSetting: null,
        isRequireVerify: false,
        hasGlobalData: false,
    },
    mutations: {
        setIsUsed(state, isUsed) {
            state.isUsed = isUsed
        },
        setRoleAccess(state, roleAccess) {
            state.roleAccess = roleAccess
            Vue.prototype.$AdminAccess = roleAccess.admin ? roleAccess.admin : []
            Vue.prototype.$GuilderAccess = roleAccess.guilder ? roleAccess.guilder : []
            Vue.prototype.$LeaderAccess = roleAccess.leader ? roleAccess.leader : []
            Vue.prototype.$KfAccess = roleAccess.kf ? roleAccess.kf : []
            Vue.prototype.$ClerkAccess = roleAccess.clerk ? roleAccess.clerk : []
        },
        setRoles(state, roles) {
            state.roles = roles
        },
        setRolePermission(state, rolePermission) {
            state.rolePermission = rolePermission
            Vue.prototype.$AdminPermission = rolePermission.admin
            Vue.prototype.$LeaderPermission = rolePermission.leader
            Vue.prototype.$KfPermission = rolePermission.kf
            Vue.prototype.$ClerkPermission = rolePermission.clerk
        },
        setRemoveClerkRole(state, removeClerkRole) {
            state.removeClerkRole = removeClerkRole
        },
        setIsResigned(state, isResigned) {
            state.isResigned = isResigned
        },
        setShop(state, shop) {
            state.shop = shop
        },
        setOrder(state, order) {
            state.order = order
        },
        setLabel(state, label) {
            state.label = label
        },
        setDdConfig(state, ddConfig) {
            state.ddConfig = ddConfig
        },
        setShopPlatformEnum(state, ShopPlatformEnum) {
            state.ShopPlatformEnum = ShopPlatformEnum
        },
        setUserSexEnum(state, UserSexEnum) {
            state.UserSexEnum = UserSexEnum
        },
        setUserInfoEnum(state, UserInfoEnum) {
            state.UserInfoEnum = UserInfoEnum;
        },
        setUserViolationTypeEnum(state, UserViolationTypeEnum) {
            state.UserViolationTypeEnum = UserViolationTypeEnum;
        },
        setUserGradeMap(state, UserGradeMap) {
            state.UserGradeMap = UserGradeMap;
        },
        setUserTagMap(state, userTagMap) {
            state.userTagMap = userTagMap;
        },
        setConstellationEnum(state, ConstellationEnum) {
            state.ConstellationEnum = ConstellationEnum
        },
        setClerkSexEnum(state, ClerkSexEnum) {
            state.ClerkSexEnum = ClerkSexEnum
        },
        setClerkStatusEnum(state, ClerkStatusEnum) {
            state.ClerkStatusEnum = ClerkStatusEnum
        },
        setClerkItemTypeEnum(state, ClerkItemTypeEnum) {
            state.ClerkItemTypeEnum = ClerkItemTypeEnum
        },
        setClerkGradeMap(state, ClerkGradeMap) {
            state.ClerkGradeMap = ClerkGradeMap
        },
        setClerkGroupMap(state, ClerkGroupMap) {
            state.ClerkGroupMap = ClerkGroupMap;
        },
        setOrderTypeEnum(state, OrderTypeEnum) {
            state.OrderTypeEnum = OrderTypeEnum
        },
        setOrderStatusEnum(state, OrderStatusEnum) {
            state.OrderStatusEnum = OrderStatusEnum
        },
        setDispatchOrderStatusEnum(state, DispatchOrderStatusEnum) {
            state.DispatchOrderStatusEnum = DispatchOrderStatusEnum
        },
        setOrderPayModeEnum(state, OrderPayModeEnum) {
            state.OrderPayModeEnum = OrderPayModeEnum
        },
        setOrderRatioTypeEnum(state, OrderRatioTypeEnum) {
            state.OrderRatioTypeEnum = OrderRatioTypeEnum
        },
        setFeatureValue(state, featureValue) {
            state.featureValue = featureValue
        },
        changeThemeColor(state, themeColor) {
            if (themeColor) {
                document.documentElement.style.setProperty('--primary-color', themeColor)
            }
        },
        loadSetting(state, setting) {
            if (setting) {
                state.shopUISetting = setting
                this.commit('changeThemeColor', setting.global.themeColor || '#42a5f5')
            }
        },
        setNeedConfirmClerkAgreement(state, needConfirmClerkAgreement) {
            state.needConfirmClerkAgreement = needConfirmClerkAgreement
        },
        setTimeUnitEnum(state, TimeUnitEnum) {
            state.TimeUnitEnum = TimeUnitEnum
        },
        setPriceTypeEnum(state, PriceTypeEnum) {
            state.PriceTypeEnum = PriceTypeEnum
        },
        setHasGlobalData(state, hasGlobalData) {
            state.hasGlobalData = hasGlobalData
        },
        setClerkSetting(state,clerkSetting){
            state.clerkSetting = clerkSetting
        },
        setShopSetting(state,shopSetting){
            state.shopSetting = shopSetting
        },
        setAccountBalanceLogActionEnum(state,AccountBalanceLogActionEnum){
            state.AccountBalanceLogActionEnum = AccountBalanceLogActionEnum
        },
        setIsRequireVerify(state,isRequireVerify){
            state.isRequireVerify = isRequireVerify
        }
    },
    actions: {
        // 获取全局数据
        getGlobalData({state, commit}) {
            return new Promise((resolve, reject) => {
                Promise.all([getGlobalData(), getShopUISetting()]).then(values => {
                    let [res, res1] = values
                    const data = res.data
                    const data1 = res1.data
                    if (data.code === 0) {
                        commit('setShop', data.shop)
                        commit('setOrder', data.order)
                        commit('setLabel', data.label)
                        commit('setDdConfig', data.ddConfig)
                        commit('setShopPlatformEnum', createEnum(data.ShopPlatformEnum))
                        commit('setUserSexEnum', createEnum(data.UserSexEnum))
                        commit('setUserInfoEnum', createEnum(data.UserInfoEnum))
                        commit('setUserViolationTypeEnum', createEnum(data.UserViolationTypeEnum))
                        commit('setUserGradeMap', data.UserGradeMap)
                        commit('setUserTagMap', data.userTagMap)
                        commit('setConstellationEnum', createEnum(data.ConstellationEnum))
                        commit('setClerkSexEnum', createEnum(data.ClerkSexEnum))
                        commit('setClerkStatusEnum', createEnum(data.ClerkStatusEnum))
                        commit('setClerkItemTypeEnum', createEnum(data.ClerkItemTypeEnum))
                        commit('setClerkGradeMap', data.ClerkGradeMap)
                        commit('setClerkGroupMap', data.ClerkGroupMap)
                        commit('setOrderTypeEnum', createEnum(data.OrderTypeEnum))
                        commit('setOrderStatusEnum', createEnum(data.OrderStatusEnum))
                        commit('setDispatchOrderStatusEnum', createEnum(data.DispatchOrderStatusEnum))
                        commit('setTimeUnitEnum', createEnum(data.TimeUnitEnum))
                        commit('setPriceTypeEnum', createEnum(data.PriceTypeEnum))
                        commit('setOrderPayModeEnum', createEnum(data.OrderPayModeEnum))
                        commit('setOrderRatioTypeEnum', createEnum(data.OrderRatioTypeEnum))
                        commit('setAccountBalanceLogActionEnum',createEnum(data.AccountBalanceLogActionEnum))
                        commit('setClerkSetting',data.clerkSetting)
                        commit('setShopSetting',data.ShopSetting)
                        commit('setIsUsed', data.isUsed)
                        if (data.featureValue) {
                            commit('setFeatureValue', new Set(data.featureValue))
                        }
                        commit('setHasGlobalData', true)
                    }
                    if (data1.code === 0) {
                        if (data1.shopUISetting) {
                            commit('loadSetting', data1.shopUISetting)
                        }
                    }
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 获取账号角色
        getAccountRoles({state, commit}) {
            return new Promise((resolve, reject) => {
                getUserRoles().then(res => {
                    if (res.data.code == 0) {
                        const data = res.data
                        commit('setRoles', data.roles)
                        commit('setRoleAccess', data.roleAccess)
                        commit('setRolePermission', data.rolePermission)
                        commit('setRemoveClerkRole', data.removeClerkRole)
                        commit('setIsResigned', data.isResigned)
                        commit('setNeedConfirmClerkAgreement', data.needConfirmClerkAgreement)
                        commit('setIsRequireVerify',data.isRequireVerify)
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
    },
    modules: {
        chat
    }
})
